import React from 'react';
import Tilt from 'react-tilt'
import { useParams } from 'react-router-dom';

import EventDescription from '../components/EventDescription'
import Banner from '../components/Banner'
import Prizes from '../components/Prizes'
import Timeline from '../components/Timeline'
import Registration from '../components/Registration'
import Breaker from '../components/Breaker'

import '../assets/css/event.css';
import eventsData from '../eventsData';
import AnimatedBackground from '../components/AnimatedBackground';
import Prizes_new from '../components/Prizes_new';
import Navbar2 from '../components/Navbar';
import Speakers from '../components/Speakers';


function Event() {
  
  let params = useParams();
  let name;
  
  if (params.id){
    name = params.id
  }
  else{
    name = 'sociopreneurs'
  }
  console.log("INSIDE EVENTS PAGE",params)
 
  var events = eventsData.filter(function(obj) {
    return obj.name==name;
  });

  console.log("EVENTS => ",events)
  
  const getData = events[0]

  
 
  return (

    <div>

        {/* POSTER */}
        <AnimatedBackground color={getData.color} name={getData.eventName}/>
        <Navbar2/>
        <Banner name={getData.eventName} poster={getData.poster} one_liner={getData.one_liner} registration_link={getData.registration_link} eventName={getData.eventName} venue={getData.venue} time={getData.time} />

        {/* Scroll dOWN */}
        <div className='new'>
          <h6 style={{color:'#fff', marginRight:'10px'}}>Scroll Down</h6>
          <img id = "Connect-button" alt="Arrow Down Icon" src="https://raw.githubusercontent.com/solodev/scroll-down-anchor/master/images/arrow-down-1.png"/>
        </div>
       
         {/* EVENT DESCRIPTION  AND POSTER*/}
        
         <div className='post'  id='down'>           
          <div className='left'>
            <div class="gallery-new">
                <div
                    class="gallery__photo-new gallery__photo--p1-new"
                >
                  
                </div>
                <div
                    class="gallery__photo-new gallery__photo--p2-new"
                >
                  
                </div>
                <div
                    class="gallery__photo-new gallery__photo--p3-new"
                >
                    <img onClick={()=> window.open("poster/"+params.id, "_blank")} style={{cursor:"pointer"}} src={getData.poster} alt={getData.eventName}/>
                </div>
                
                <div className='boxbox-new'>
                    
                </div>
              </div>
          </div> 
           <div className='mid'>
            </div>
          <div className='right'>
            <Tilt className="each-event" style={{ backgroundColor: "transparent"}}>
                <EventDescription name={getData.eventName} poster={getData.poster} description={getData.description} />
            </Tilt> 
          </div>             
        </div>
         <div className='mob-desc'>       
            <EventDescription name={getData.eventName} poster={getData.poster} description={getData.description} />
         </div>
        {/*  PRIZES */}
        <Breaker/>
        {"speakers" in getData ? <Speakers speakers = {getData.speakers} title={getData.speakertit}/> : <></>}
        <Prizes_new prizes = {getData.prizes} name = {getData.eventName}/>

       
        

         {/* TIMELINES */}
         <Breaker/>
         {name == 'aurora' ? <></> :  <Timeline timeline={getData.timeline}/>}
        

        {/* REGISTRATION LINK */}
        <div className='btn'>
            <a href="https://www.kaizeniitd.in"><h3 style={{color: 'gray'}}>Home</h3></a>
        </div>                         
       </div>
  )
}

export default Event